import { useEffect } from 'react'
import { LOYALTY_USE_API } from '../config'
import { useLoyaltyStore } from '../store/useLoyaltyStore'

/**
 * Hydrates the store from the backend when the seam is open, and does nothing
 * at all when it is not. Called by the page so that turning `LOYALTY_USE_API`
 * on is the only change needed here once the endpoint exists.
 */
export function useLoyaltyQuery() {
  const importProgram = useLoyaltyStore(s => s.importProgram)

  useEffect(() => {
    if (LOYALTY_USE_API) {
      // The GET goes here, mapped through a mapper beside the API file, exactly
      // as features/floor-plan/api does it. Intentionally absent rather than
      // stubbed: a fake request that resolves is worse than none, it makes the
      // page look wired when it is not.
    }
  }, [importProgram])

  return { isBackedByApi: LOYALTY_USE_API }
}
